import Info from '../Info/Info';
import Themes from '../Themes';

const Label = ({ text, tooltipInfo, theme, mandatory, className = '' }) => {
    return (
        <div className={`flex font-sf items-center text-13 h-4 font-medium ${className}`}>
            {text}
            {mandatory && <span className="ml-1 top-11">*</span>}
            {tooltipInfo && <Info theme={Themes[theme] || Themes.Light} className="ml-1" tooltipInfo={tooltipInfo} />}
        </div>
    );
};

export default Label;
